import type { State } from './typings'

export const initialState: State = {
  callTrackingDetails: {
    entityCallTrackingSystemFields: [],
    isCallTrackingEnabled: false,
    isProcessing: false,
  },
}
